import { useMemo, useState } from "react";

export const useFilterAndSort = (tasks) => {
  const [search, setSearch] = useState("");
  const [priority, setPriority] = useState("All");
  const [assigneeId, setAssigneeId] = useState("All");
  const [sortBy, setSortBy] = useState("none"); // 'dueDate' | 'priority'

  const filteredTasks = useMemo(() => {
    let result = [...tasks];

    if (search.trim()) {
      const lower = search.toLowerCase();
      result = result.filter(
        (t) =>
          t.title.toLowerCase().includes(lower) ||
          (t.description || "").toLowerCase().includes(lower)
      );
    }

    if (priority !== "All") {
      result = result.filter((t) => t.priority === priority);
    }

    if (assigneeId !== "All") {
      result = result.filter((t) => t.assigneeId === assigneeId);
    }

    if (sortBy === "dueDate") {
      result.sort(
        (a, b) => new Date(a.dueDate || 0) - new Date(b.dueDate || 0)
      );
    }

    if (sortBy === "priority") {
      const order = { High: 1, Medium: 2, Low: 3 };
      result.sort((a, b) => (order[a.priority] || 99) - (order[b.priority] || 99));
    }

    return result;
  }, [tasks, search, priority, assigneeId, sortBy]);

  return {
    search,
    priority,
    assigneeId,
    sortBy,
    setSearch,
    setPriority,
    setAssigneeId,
    setSortBy,
    filteredTasks,
  };
};
